import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { eventApi } from '../api/eventApi';
import {Event } from '../../components/events/types';
import Cookies from 'js-cookie';

interface EventResponse {
  events?: Event[];
  is_end?: boolean;
  account_balances?: { [key: string]: number };
}
export interface EventState {
  response: EventResponse| undefined;
  step: number;
  selectedEvent: Event | null;
  is_active: boolean | undefined;
  event_type: string | undefined;
  city: string | undefined;
  sort_by:string | undefined;
}

const loadFromLocalStorage = (key: string) => {
  try {
    const serializedState = localStorage.getItem(key);
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (e) {
    console.warn('Error loading from localStorage', e);
    return undefined;
  }
};

const saveToLocalStorage = (key: string, state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(key,serializedState);
  } catch (e) {
    console.warn('Error saving to localStorage', e);
  }
};

const initialState: EventState = {
  response: undefined,
  step: loadFromLocalStorage('step') ?? 1, 
  selectedEvent: loadFromLocalStorage('selectedEvent') ?? null,
  is_active: true, 
  event_type: undefined,
  city: undefined,
  sort_by:undefined
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    setStep(state, action: PayloadAction<number>) {
      state.step = action.payload;
      saveToLocalStorage('step', state.step);
    },
    setSelectedEvent(state, action: PayloadAction<Event | null>) {
      state.selectedEvent = action.payload;
      saveToLocalStorage('selectedEvent', state.selectedEvent);
    },

    setIsActive(state, action: PayloadAction<boolean | undefined>) {
      state.is_active = action.payload;
    },
    setEventType(state, action: PayloadAction<string | undefined>) {
      state.event_type = action.payload;
    },
    setCity(state, action: PayloadAction<string | undefined>) {
      state.city = action.payload;
    },
    setSortby(state, action: PayloadAction<string | undefined>) {
      state.sort_by = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(eventApi.endpoints.getEvents.matchFulfilled, (state, { payload }: any) => {
        state.response = payload.data; 
      });
  },
});

export const { setStep, setSelectedEvent, setIsActive, setEventType, setCity,setSortby } = eventSlice.actions;
export default eventSlice.reducer;
